module.exports = __webpack_public_path__ + "img/7-original.57a190e4.svg";